import type { ScorecardCadence, ScorecardStatus, ScorecardUnit } from '../../../types/admin';

export const SCORECARD_STATUS: Record<ScorecardStatus, { label: string; color: 'neutral' | 'primary' | 'success' | 'warning' | 'danger' }> = {
  missing: { label: 'Missing', color: 'neutral' },
  in_progress: { label: 'In progress', color: 'primary' },
  needs_review: { label: 'Needs review', color: 'warning' },
  not_applicable: { label: 'N/A', color: 'neutral' },
  no_target: { label: 'No target', color: 'warning' },
  on_track: { label: 'On track', color: 'success' },
  off_track: { label: 'Off track', color: 'danger' },
};

export function formatScore(value: string | null | undefined, unit: ScorecardUnit, compact = false): string {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return '—';
  const number = Number(value);
  if (unit === 'currency') return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: compact ? 1 : 2, notation: compact ? 'compact' : 'standard' }).format(number);
  const formatted = new Intl.NumberFormat('en-US', { maximumFractionDigits: unit === 'count' ? 0 : 2 }).format(number);
  return unit === 'percent' ? `${formatted}%` : unit === 'hours' ? `${formatted}h` : formatted;
}

export function formatPeriod(value: string, cadence: ScorecardCadence, year = false): string {
  return new Date(`${value}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', ...(cadence === 'weekly' ? { day: 'numeric' } : {}), ...(year || cadence === 'monthly' ? { year: 'numeric' } : {}), timeZone: 'UTC' });
}

export function movePeriod(value: string, cadence: ScorecardCadence, steps: number): string {
  const date = new Date(`${value}T12:00:00Z`);
  if (cadence === 'weekly') date.setUTCDate(date.getUTCDate() + steps * 7);
  else date.setUTCMonth(date.getUTCMonth() + steps, 1);
  return date.toISOString().slice(0, 10);
}

export function normalizePeriod(value: string, cadence: ScorecardCadence): string {
  const date = new Date(`${value}T12:00:00Z`);
  if (!Number.isFinite(date.getTime())) return '';
  if (cadence === 'monthly') date.setUTCDate(1);
  else date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7);
  return date.toISOString().slice(0, 10);
}
